import { ReactElement } from 'react';
import { useTranslation } from '@jobcost-monorepo/i18n';

const ReplicateFormTitle = (): ReactElement => {
  const { t } = useTranslation('timesheets');

  return (
    <div>
      <p className="text-pink text-2xl">{t(`replicate.title`)}</p>
    </div>
  );
};

export default ReplicateFormTitle;
